import { useEffect } from "react";
import Header from "components/Common/Header/Header";
import ContractBody from "components/ClinicalManagement/HealthCenters/Details/HealthCenterContracts/ContractBody";

const HealthCenterContracts = () => {
  useEffect(() => {
    document.title = "Contracts";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <ContractBody />
    </main>
  );
};

export default HealthCenterContracts;
